export const ABSENCE_ACTIVITY_TYPE = 'CrewMemberAbsenceActivityItem';
export const WORK_ASSIGNMENT_ACTIVITY_TYPE = 'CrewMemberWorkAssignmentActivityItem';
export const ON_ASSIGNMENT_STATUS_TYPE = 'onAssignment';
export const ON_ASSIGNMENT_ACTIVITY_TYPE = 'onassignment';
export const ON_ASSIGNMENT_UNKNOWN_ACTIVITY_TYPE = 'unknown';
export const DEADHEAD_ACTIVITY_TYPE = 'deadhead';
export const PROTECTION_ACTIVITY_TYPE = 'protection';
export const TRAVELLING_ACTIVITY_TYPE = 'traveling';
export const DRIVING_ACTIVITY_TYPE = 'driving';
export const HOSTING_ACTIVITY_TYPE = 'hosting';
export const WA_OVERLAPPING_ACTIVITIES_RESPONSE = 'WorkAssignmentOverlappingActivitiesResponse';
export const WA_AUXILIARY_SHIFT_TIME_TOO_LONG_ERROR = 'shiftTimeTooLong';
export const WA_AUXILIARY_SUCCESS_RESPONSE = 'WorkAssignmentAuxiliaryMutationSuccessResponse';
export const WA_AUXILIARY_ERROR_RESPONSE = 'WorkAssignmentAuxiliaryMutationErrorResponse';
